<template>
    <div id="footer_wrap" class="outer">
        <footer class="inner">
            <p v-html="support"></p>
            <p>{{ copyright }}</p>
        </footer>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                support: 'If you have any issues or suggestions, please email <span style="text-decoration: underline;">support@titocontrol.com</span> for assistance.',
                copyright: 'Copyright © 2016-2019 Feng YiHua. All rights reserved.'
            }
        }
    }
</script>

<style>
    #footer_wrap {
        background: #f7f7f7;
    }

    #footer_wrap .inner {
        color: #000000;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 14px;
        font-weight: 400;
    }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue